import React, { useEffect, useState } from "react";
import "./style.scss";
import { withRouter } from "react-router-dom";
import hashImage from "../../../../../assets/images/hashImage.jpeg";
import mentorProfile1 from "../../../../../assets/images/mentor-profile1.png";

import { connect } from "react-redux";
import mentorProfile2 from "../../../../../assets/images/mentor-profile2.png";
import profileBackground from "../../../../../assets/images/profile-back01.jpg";
import profileBackground2 from "../../../../../assets/images/profile-back02.jpg";
import linkedin from "../../../../../assets/images/linkedin.png";
import globe from "../../../../../assets/images/globe.png";
import { getStartupListData } from "../../../../GetMentor/dependencies/action";

function SingleStartUp(props) {
  const { getStartupListData, getSingleStartupData } = props;
  const [viewApplicationData, setViewApplicationData] = useState();

  useEffect(() => {
    let params;
    if (window.id != undefined && window.id != null && window.id != "") {
      params = { id: window.id };
    } else {
      let dpiit_no = window.location.pathname.split("/");

      params = { id: dpiit_no[dpiit_no.length - 1] };
    }
    getStartupListData(params);
  }, []);
  useEffect(() => {
    setViewApplicationData(getSingleStartupData);
  }, [getSingleStartupData]);
  return (
    <div className="singleMentor">
      <section id="banner">
        <div class="w-100 pt-50 pb-50 position-relative">
          <div class="container">
            <div className="backbtnviewprofile"></div>
            <div class="row">
              <div class="col-md-3 col-sm-12 col-lg-3 wow slideInLeft text-center">
                {viewApplicationData && viewApplicationData.entity_name ? (
                  <a className="single-mentor-headline2">
                    {viewApplicationData && viewApplicationData.entity_name}{" "}
                  </a>
                ) : (
                  <h1>Name is not available </h1>
                )}
              </div>

              <div
                class="col-md-6 col-sm-12 col-lg-6 wow slideInRight d-none d-sm-flex"
                style={{ right: "1rem", position: "relative", top: "1rem" }}
              >
                <img
                  src={mentorProfile1}
                  style={{ width: "50%", height: "fit-content" }}
                />
              </div>
              <div class="col-md-3 col-sm-12 col-lg-3 "></div>
            </div>
          </div>
          <div class="container">
            <div class="row">
              <div class="col-md-3 col-sm-12 col-lg-3 wow slideInLeft p-0 px-1">
                <div>
                  <div
                    class="mckp-img text-center tilt w-100 d-block position-relative"
                    style={{ height: "auto" }}
                  >
                    {" "}
                    <img
                      class="img-fluid imageSource d-block"
                      src={
                        viewApplicationData &&
                        viewApplicationData.upload_logo !== null
                          ? viewApplicationData &&
                            viewApplicationData.upload_logo
                          : hashImage
                      }
                      style={{
                        maxHeight: "280px",
                        height: "275px",
                        objectFit: "contain",
                        objectPosition: "center",
                        border: "1px solid #3e495438",
                        padding: "0px",
                        borderRadius: "3px",
                        background: "#eeeeee",
                      }}
                      alt=""
                    />
                    {viewApplicationData?.upload_document !== null && (
                      <>
                        <div className="newuserTooltip top-btn">
                          <a
                            class="complete-btn mentor-btn viewResumePosition"
                            target="_blank"
                            href={viewApplicationData?.upload_document}
                          >
                            VIEW STARTUP DECK
                          </a>
                          <span className="tooltiptext viewResume tooltip-bottom">
                            View Startup Deck
                          </span>
                        </div>
                      </>
                    )}
                  </div>
                  <div class="container" style={{ height: "auto" }}>
                    <div class="row pt-0" id="mentor-details">
                      <div class="col-md-12 col-sm-12 col-lg-12">
                        <div class="row">
                          <div class="col-md-3 col-sm-12 col-lg-3 wow fadeInDown displayNone d-none d-sm-flex align-items-start">
                            <img src={mentorProfile2} />
                          </div>
                          <div
                            class="col-md-4 col-sm-12 col-lg-3 pt-10 wow sociallinkicon fadeInDown d-flex socialiconmobile"
                            style={{
                              width: "100%",
                              position: "absolute",
                              // display: 'flex' !important;
                              justifyContent: "right",
                              left: "0%",
                            }}
                          >
                            <div
                              class="mentor-social"
                              style={{
                                position: "relative",
                                marginRight: "2%",
                                paddingTop: "2px",
                                width: "21px",
                              }}
                            >
                              {viewApplicationData &&
                              viewApplicationData.appLindin_url !== null ? (
                                <div className="newuserTooltip">
                                  <a
                                    href={
                                      viewApplicationData &&
                                      viewApplicationData.appLindin_url
                                    }
                                    target="_blank"
                                  >
                                    <img src={linkedin} />
                                  </a>
                                  <span
                                    className="tooltiptext  tooltip-bottom"
                                    style={{ left: "-2px", width: "156px" }}
                                  >
                                    View LinkedIn Profile
                                  </span>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                            <div class="mentor-social">
                              {viewApplicationData &&
                              viewApplicationData.startupwebsite !== null ? (
                                <div className="newuserTooltip">
                                  <a
                                    href={
                                      viewApplicationData &&
                                      viewApplicationData.startupwebsite
                                    }
                                    target="_blank"
                                  >
                                    <img src={globe} />
                                  </a>
                                  <span
                                    className="tooltiptext  tooltip-bottom"
                                    style={{ left: "16px", width: "126px" }}
                                  >
                                    View Website
                                  </span>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                          <div class="col-md-5 col-sm-12 col-lg-6 wow fadeInDown marginAuto">
                            <div class="top top-disc">
                              <div class="top-circle"></div>
                              <div class="top-circle">&nbsp;</div>
                              <div class="top-circle"></div>
                            </div>
                            <div
                              class="marginAuto"
                              style={{ minWidth: "10vw" }}
                            >
                              <img
                                src={
                                  viewApplicationData &&
                                  viewApplicationData.upload_profile !== null
                                    ? viewApplicationData &&
                                      viewApplicationData.upload_profile
                                    : hashImage
                                }
                                style={{ width: "100%", margin: "0 auto" }}
                              />
                            </div>
                          </div>
                          <div class="col-md-4 col-sm-12 col-lg-3 pt-10 wow sociallinkicon fadeInDown d-flex socialicondesk">
                            <div
                              class="mentor-social"
                              style={{
                                position: "relative",
                                marginRight: "5%",
                                paddingTop: "2px",
                                width: "21px",
                              }}
                            >
                              {viewApplicationData &&
                              viewApplicationData.appLindin_url !== null ? (
                                <div className="newuserTooltip">
                                  <a
                                    href={
                                      viewApplicationData &&
                                      viewApplicationData.appLindin_url
                                    }
                                    target="_blank"
                                  >
                                    <img src={linkedin} />
                                  </a>
                                  <span
                                    className="tooltiptext  tooltip-bottom"
                                    style={{ left: "-2px", width: "156px" }}
                                  >
                                    View LinkedIn Profile
                                  </span>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                            <div class="mentor-social">
                              {viewApplicationData &&
                              viewApplicationData.startupwebsite !== null ? (
                                <div className="newuserTooltip">
                                  <a
                                    href={
                                      viewApplicationData &&
                                      viewApplicationData.startupwebsite
                                    }
                                    target="_blank"
                                  >
                                    <img src={globe} />
                                  </a>
                                  <span
                                    className="tooltiptext  tooltip-bottom"
                                    style={{ left: "16px", width: "126px" }}
                                  >
                                    View Website
                                  </span>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                          <div>
                            <h3
                              class="text-center"
                              style={{
                                padding: "25px 0px 0px",
                                fontSize: "18px",
                              }}
                            >
                              CURRENT MENTORSHIPS
                            </h3>
                            <p class="mentor-num">
                              <div class="cir">
                                <div class="circle"></div>
                                <div class="line"></div>
                                <div class="circle">0</div>
                                <div class="line"></div>
                                <div class="circle"></div>
                              </div>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-8 col-sm-12 col-lg-8 wow slideInRight p-md-0">
                <div className="m-0 p-0 container h-100">
                  <div className="row">
                    <div class="col-md-8 col-sm-12 col-lg-12 wow fadeInDown">
                      <div className="m-0 p-0 container h-100">
                        <div class="row">
                          <div
                            class="col-md-6 col-sm-12 col-lg-6 wow"
                            style={{ paddingRight: "0" }}
                          >
                            <div
                              class="profile-data pb-5"
                              style={{
                                backgroundImage: { profileBackground },
                                backgroundPosition: "bottom right",
                                backgroundSize: "cover",
                                backgroundRepeat: "no-repeat",
                              }}
                            >
                              <div className="mh-50">
                                {viewApplicationData &&
                                viewApplicationData.applicant_name !== null ? (
                                  <div class="sub-data">
                                    <h3>Contact Name </h3>
                                    <h4 className="pt-2">
                                      {viewApplicationData &&
                                        viewApplicationData.applicant_name}
                                    </h4>
                                  </div>
                                ) : (
                                  <div class="sub-data">
                                    <h3>Contact Name </h3>
                                    <h4 className="pt-2">-</h4>
                                  </div>
                                )}
                                {viewApplicationData &&
                                viewApplicationData.designation !== null ? (
                                  <div class="sub-data">
                                    <h3>Designation </h3>
                                    <h4 className="pt-2">
                                      {viewApplicationData &&
                                        viewApplicationData.designation}
                                    </h4>
                                  </div>
                                ) : (
                                  <div class="sub-data">
                                    <h3>Designation </h3>
                                    <h4 className="pt-2">-</h4>
                                  </div>
                                )}
                                {viewApplicationData &&
                                viewApplicationData?.state_name !== "" ? (
                                  <div class="sub-data">
                                    <h3>State </h3>
                                    <h4 className="pt-2">
                                      {viewApplicationData &&
                                        viewApplicationData?.state_name}
                                    </h4>
                                  </div>
                                ) : (
                                  <div class="sub-data">
                                    <h3>State </h3>
                                    <h4 className="pt-2">-</h4>
                                  </div>
                                )}

                                {viewApplicationData &&
                                viewApplicationData.city !== null ? (
                                  <div class="sub-data">
                                    <h3>City </h3>
                                    <h4 className="pt-2">
                                      {viewApplicationData &&
                                        viewApplicationData.city}
                                    </h4>
                                  </div>
                                ) : (
                                  <div class="sub-data">
                                    <h3>City</h3>
                                    <h4 className="pt-2">-</h4>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6 col-sm-12 col-lg-6  fadeInDown">
                            <div
                              class="profile-data2  pb-5"
                              style={{
                                background: { profileBackground2 },
                                backgroundPosition: "bottom right",
                                backgroundSize: "cover",
                                backgroundRepeat: "no-repeat",
                              }}
                            >
                              {viewApplicationData &&
                              viewApplicationData.dpiit_no !== null ? (
                                <div class="sub-data">
                                  <h3>DPIIT ID</h3>
                                  <h4 className="pt-2">
                                    {viewApplicationData &&
                                      viewApplicationData.dpiit_no}
                                  </h4>
                                </div>
                              ) : (
                                <div class="sub-data">
                                  <h3>DPIIT ID</h3>
                                  <h4 className="pt-2">-</h4>
                                </div>
                              )}
                              {viewApplicationData &&
                              viewApplicationData.sector !== null ? (
                                <div class="sub-data">
                                  <h3>Sector </h3>
                                  <h4 className="pt-2">
                                    {viewApplicationData &&
                                      viewApplicationData.sector}
                                  </h4>
                                </div>
                              ) : (
                                <div class="sub-data">
                                  <h3>Sector </h3>
                                  <h4 className="pt-2">-</h4>
                                </div>
                              )}

                              {viewApplicationData &&
                              viewApplicationData.industry !== null ? (
                                <div class="sub-data">
                                  <h3>Industry </h3>

                                  <h4 className="pt-2">
                                    {viewApplicationData.industry}
                                  </h4>
                                </div>
                              ) : (
                                <div class="sub-data">
                                  <h3>Industry </h3>

                                  <h4 className="pt-2">-</h4>
                                </div>
                              )}
                              {viewApplicationData &&
                              viewApplicationData.services !== null ? (
                                <div class="sub-data">
                                  <h3>Function </h3>

                                  <h4 className="pt-2">
                                    {viewApplicationData?.services.map(
                                      (item, index) => (
                                        <h4
                                          style={{ lineHeight: "35px" }}
                                          key={index}
                                        >
                                          {item}
                                        </h4>
                                      )
                                    )}
                                  </h4>
                                </div>
                              ) : (
                                <div class="sub-data">
                                  <h3>Function </h3>

                                  <h4 className="pt-2">NA</h4>
                                </div>
                              )}
                              {viewApplicationData &&
                              viewApplicationData.stage !== null ? (
                                <div class="sub-data">
                                  <h3>Stage</h3>
                                  <h4 className="pt-2">
                                    {viewApplicationData.stage}
                                  </h4>
                                </div>
                              ) : (
                                <div class="sub-data">
                                  <h3>Stage</h3>
                                  <h4 className="pt-2">-</h4>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {viewApplicationData &&
                    viewApplicationData.offered_startup !== null &&
                    viewApplicationData.offered_startup !== "" ? (
                      <div className="col-md-6 col-sm-12 col-lg-12  profileExtra 1st">
                        <div class="sub-data">
                          <h3 className="mt-2">Core Services offered</h3>

                          <h4 className="pt-2 profileextraptmobile">
                            {viewApplicationData &&
                              viewApplicationData.offered_startup}
                          </h4>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {viewApplicationData &&
                    viewApplicationData.problem_solved !== null &&
                    viewApplicationData.problem_solved !== "" ? (
                      <div className="col-md-6 col-sm-12 col-lg-12  profileExtra 2nd">
                        <div class="sub-data">
                          <h3 className="mt-2">Problem Being Solved</h3>
                          <h4 className="pt-2 profileextraptmobile">
                            {viewApplicationData &&
                              viewApplicationData.problem_solved}
                          </h4>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {viewApplicationData &&
                    viewApplicationData.whyneedMentorship !== null &&
                    viewApplicationData.whyneedMentorship !== "" ? (
                      <div className="col-md-6 col-sm-12 col-lg-12  profileExtra 3rd">
                        <div class="sub-data">
                          <h3 className="mt-2">Need for Mentorship</h3>
                          <h4 className="pt-2 profileextraptmobile">
                            {viewApplicationData &&
                              viewApplicationData.whyneedMentorship}
                          </h4>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {viewApplicationData &&
                    viewApplicationData.whyneedMentorship !== null &&
                    viewApplicationData.whyneedMentorship !== "" ? (
                      <div className="col-md-6 col-sm-12 col-lg-12  profileExtra 4th">
                        <div class="sub-data">
                          <h3 className="mt-2">
                            Expected Outcomes from Mentorship Sessions
                          </h3>
                          <h4 className="pt-2 profileextraptmobile">
                            {viewApplicationData &&
                              viewApplicationData.expected_outcome}
                          </h4>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    getSingleStartupData: state.GetMentorDataReducer.startupListData.data,
  };
};
export default connect(mapStateToProps, { getStartupListData })(
  withRouter(SingleStartUp)
);
